export const CONTACT = {
  email: "upscwithease@gmail.com",
  youtube: "https://www.youtube.com/@ArpitaSharma",
  telegram: "https://telegram.me/ArpitaSharma",
};

export const TARGET_YEARS = ["2026", "2027", "2028", "2029", "2030"];

export const REFERRAL_SOURCES = ["YouTube", "Telegram", "Instagram", "Friend", "Other"];

export const INDIAN_STATES = [
  "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh", "Goa",
  "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand", "Karnataka", "Kerala",
  "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya", "Mizoram", "Nagaland",
  "Odisha", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana", "Tripura",
  "Uttar Pradesh", "Uttarakhand", "West Bengal", "Delhi (NCT)", "Jammu & Kashmir",
  "Ladakh", "Puducherry", "Chandigarh", "Andaman & Nicobar Islands", "Other",
];

export const DISCLAIMER =
  "UPSC With Arpita is an independent educational platform and is not affiliated with, endorsed by, or connected to the Union Public Service Commission (UPSC) or the Government of India.";

export const COMING_SOON = [
  { title: "Prelims Mock Tests", desc: "Attempt UPSC-style timed Prelims mocks with instant scoring & solutions.", live: true, to: "/mock-tests" },
  { title: "Current Affairs Tests", desc: "Attempt weekly & monthly current-affairs quizzes with instant scoring.", live: true, to: "/mock-tests?category=current-affairs" },
  { title: "Arpita's Notes", desc: "Curated, exam-ready handwritten notes by Arpita." },
  { title: "PYQ Archive", desc: "Topic-wise previous year questions with analysis." },
];
